import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { store } from './store';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Blogs from './pages/Blogs';
import Coupons from './pages/Coupons';
import Orders from './pages/Orders';
import FAQs from './pages/FAQs';
import Terms from './pages/Terms';
import Contacts from './pages/Contacts';
import FooterManagement from './pages/FooterManagement';
import Banners from './pages/Banners';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="products" element={<Products />} />
              <Route path="categories" element={<Categories />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="orders" element={<Orders />} />
              <Route path="faqs" element={<FAQs />} />
              <Route path="terms" element={<Terms />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="footer" element={<FooterManagement />} />
              <Route path="banners" element={<Banners />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;